import App from "./App";
import GlobalStyles from "./theme/global";
import React from "react";
import ReactDOM from "react-dom/client";
import {StyleSheetManager, ThemeProvider} from "styled-components";
import { theme } from "./theme/theme";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { store } from "./redux/store";
// import "./api/axiosCfg";

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
          <StyleSheetManager disableCSSOMInjection>
        <ThemeProvider theme={theme}>
          <GlobalStyles />
          <App />
        </ThemeProvider>
          </StyleSheetManager>
      </BrowserRouter>
    </Provider>
  </React.StrictMode>,
);
